export const getAccountId = (appDefId: string, appInstanceId: string): string =>
  `${appDefId}:${appInstanceId}`;
